import type { ReactNode } from "react";

export interface ServiceReviewNewViewProps {
  /**
   * The wired "leave a review" modal. The container owns it because it holds
   * Inertia form state, precognition and the routed modal; the view simply
   * presents whatever modal it is handed.
   */
  children: ReactNode;
}

/**
 * Presentational shell for the service review "new" page. The page is a thin
 * wrapper whose only job is to present the review form modal, so the view
 * renders the composed modal it receives.
 */
export function ServiceReviewNewView({ children }: ServiceReviewNewViewProps) {
  return <>{children}</>;
}
